import { BrowserAuthError, BrowserAuthErrorCodes } from "@azure/msal-browser";
import { datadogLogs } from "@datadog/browser-logs";

interface DatadogSettings {
  readonly connectionString: string;
  readonly version: string;
  readonly tags: string;
}
export function initializeDatadog(settings: DatadogSettings) {
  if (!settings.connectionString) return;

  let additionalTagString = "";
  if (settings.tags) {
    // Tags come space separated, should be comma separated for browser log
    additionalTagString = "," + settings.tags.replaceAll(" ", ",");
  }

  datadogLogs.init({
    clientToken: settings.connectionString,
    site: "datadoghq.eu",
    service: "knop-ui",
    version: settings.version,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["log", "warn", "error"],
    sessionSampleRate: 100,
    beforeSend: (event, _): boolean => {
      if (event.origin === "network") return false;
      if (event.error instanceof TypeError && event.error.message === "Failed to fetch") {
        return false;
      }
      // Ugly exclude for not finding localizations for Lion forms (used by Tractie).
      // Why exactly it fails is still a bit of a mystery, but the translations are
      // not really used anyways (for now).
      if (event.error?.message?.startsWith("Data for namespace")) return false;
      // Logs an error which alerts to check the configured redirect URI.
      // The Redirect URI is correct, sometimes weird network things happen which causes hash to be
      // empty. So ignore error in Datadog for now.
      if (
        event.error instanceof BrowserAuthError &&
        event.error.errorCode === BrowserAuthErrorCodes.hashEmptyError
      ) {
        return false;
      }
      event.ddtags += additionalTagString; // Format is key:value,key:value
      return true;
    },
  });
}
